import omit from 'lodash.omit';
const MANUAL_STRATEGY_GROUP_FIELDS_TO_REMOVE = ['autostrategy_arguments_values', 'autostrategy_id'];
const MANUAL_STRATEGY_GROUP_OPTIONS_FIELDS_TO_REMOVE = ['fallbackRule'];
const MANUAL_STRATEGY_GROUP_RULE_FIELDS_TO_REMOVE = ['uid'];

export default function manualStrategyGroupSerializer (group) {
  group = omit(group, MANUAL_STRATEGY_GROUP_FIELDS_TO_REMOVE);
  group.options = omit(group.options, MANUAL_STRATEGY_GROUP_OPTIONS_FIELDS_TO_REMOVE);
  group.options.rules = group.options.rules.map(i => omit(i, MANUAL_STRATEGY_GROUP_RULE_FIELDS_TO_REMOVE));
  return group;
}
